import { useCallback, useEffect, useState } from "react";

export function useSidebar(widthScreen: number) {
  const [isExpanded, setIsExpanded] = useState<boolean>(
    localStorage.getItem("sidebar") === "true",
  );
  useEffect(() => {
    if ("sidebar" in localStorage) {
      return;
    }
    if (widthScreen <= 1280) {
      setIsExpanded(false);
    } else {
      setIsExpanded(true);
    }
  }, [widthScreen]);

  const handleSetExpandedStatus = useCallback((value: boolean) => {
    setIsExpanded(value);
    localStorage.setItem("sidebar", `${value}`);
  }, []);

  return {
    isSidebarExpanded: isExpanded,
    setIsExpanded: handleSetExpandedStatus,
  };
}
